window.dataLayer = window.dataLayer || [];

(function () {
  var gtmLoaded = false;

  function loadGTM() {
    if (gtmLoaded) return;
    gtmLoaded = true;

    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    var f = document.getElementsByTagName('script')[0],
      j = document.createElement('script'),
      dl = 'dataLayer' != 'dataLayer' ? '&l=dataLayer' : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-M5WPPQ29' + dl;
    f.parentNode.insertBefore(j, f);
  }

  var events = ['scroll', 'mousemove', 'touchstart', 'click', 'keydown'];
  events.forEach(function (evt) {
    window.addEventListener(evt, loadGTM, { once: true, passive: true });
  });

  setTimeout(loadGTM, 3500);
})();
